<script setup lang="ts">
import { useNavProgress } from '@/composables/useNavProgress'

const { isVisible, progress } = useNavProgress()
</script>

<template>
  <Transition name="nav-progress">
    <div
      v-if="isVisible"
      class="fixed top-0 left-0 z-[9999] h-[3px] bg-secondary"
      :style="{ width: `${progress}%` }"
      data-testid="nav-progress-bar"
    />
  </Transition>
</template>

<style scoped>
div {
  transition: width 150ms linear;
}

.nav-progress-leave-active {
  transition: opacity 0.3s ease;
}
.nav-progress-leave-to {
  opacity: 0;
}
</style>
